import React, { useEffect, useState } from "react";
import BaseModal from "./BaseModal";
import { X, CircleUser, Phone } from "lucide-react";
import PrimaryBtn from "../button/PrimaryBtn";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getCustomerDetailById } from "../../redux/thunks/addCustomerThunk";

const CustomerAdded = ({ open, onclose, onAddQuickOrder, customerId }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    if (!open || !customerId) return;

    const payload = {
      customer_id: customerId,
    };
    // console.log("The payload of customer adding is :", payload);
    dispatch(getCustomerDetailById(payload))
      .unwrap()
      .then((res) => {
        // console.log("FULL RESPONSE:", res);
        // console.log("RES.DATA:", res.data);
        setCustomer(res.data); // 🔥 save data
      })
      .catch((err) => {
        console.error(err);
      });
  }, [dispatch, customerId, open]);

  return (
    <BaseModal open={open} onClose={onclose}>
      <div className="p-6 text-center space-y-4">
        <div className="  h-10 w-10 rounded-full bg-[#FFEFEB] flex items-center justify-center">
          <X
            className="text-[#FF6943] cursor-pointer"
            size={15}
            onClick={onclose}
          />
        </div>
        <h1>Share Link</h1>
        <div className="border-b border-gray-100"></div>
        <div className="flex flex-col justify-center items-center space-y-3">
          <div className="p-2 rounded-full bg-[#FFEFEB] border border-[#FFEFEB]">
            <CircleUser size={100} className="text-[#FB6742]" />
          </div>
          <p className="text-center text-sm">{customer?.customer_name}</p>

          <p className="text-sm text-center flex gap-2 text-[#969495]">
            <Phone size={15} />
            {customer?.contact_no}
          </p>
        </div>
        <div className="flex justify-between w-full gap-2 flex-col md:flex-row">
          <PrimaryBtn
            btnName="share tiffin service"
            clickEvent={() => navigate(`/customer/${customerId}`)}
          />

          <PrimaryBtn btnName="Add Quick Order" clickEvent={onAddQuickOrder} />
        </div>
      </div>
    </BaseModal>
  );
};

export default CustomerAdded;
